module.exports = __webpack_public_path__ + "static/media/4ODA15.6afe2751.jpg";